const WINDOW_WIDTH_MIN_PX = {
  EXTRA_SMALL: 0,
  SMALL: 480,
  MEDIUM: 768,
  LARGE: 992,
  EXTRA_LARGE: 1200
};

export { WINDOW_WIDTH_MIN_PX };
